'use client';

import styles from './serviceProviderCard.module.scss';
import Image from 'next/image';
import { GlobalContext } from 'context';
import { useContext } from 'react';
import { AppLinkComp } from 'components';
function ServiceProviderCardComp({
  item,
  className
}: {
  item: {
    title: string;
    description: string;
    img: string;
  };
  className?: string;
}) {
  const lang = useContext(GlobalContext).langText.components;
  return <div title={item.description} className={`${styles['provider-card']} d-flex align-items-center ${className ?? ''}`} data-sentry-component="ServiceProviderCardComp" data-sentry-source-file="serviceProviderCard.index.tsx">
            <Image src={item.img} width={144} height={144} objectFit="cover" alt="image" data-sentry-element="Image" data-sentry-source-file="serviceProviderCard.index.tsx" />
            <div className={`${styles['content-layout']}`}>
                <p className={`${styles['title']} t-700 t-p1 t-dark1`}>{item.title}</p>
                <div className={`${styles['desc']} t-400 t-p2 t-dark3 pv-2`}>
                    {item.description.length < 75 ? item.description : item.description.slice(0, 72) + '...'}
                </div>
                <AppLinkComp href="/" className="t-primary t-400 t-p2" data-sentry-element="AppLinkComp" data-sentry-source-file="serviceProviderCard.index.tsx">
                    {lang.see_more}
                </AppLinkComp>
            </div>
        </div>;
}
export default ServiceProviderCardComp;